// extracted by mini-css-extract-plugin
module.exports = {"viewTrailerButtonFrame":"Bp","viewTrailerButton":"Bq","cta":"Br","trailerIcon":"Bs"};